let store;

export const injectStore = (_store) => {
  store = _store;
};

export const getStore = () => {
  if (!store) {
    console.warn("Store was accessed before injection");
  }
  return store;
};
